import { createEffect, createSignal, onCleanup } from "solid-js";

export const useThinkingElapsedSeconds = (props: {
	startedAtMs: number;
	thinkingEndedAtMs?: number;
}) => {
	const elapsedEndMs = () => props.thinkingEndedAtMs ?? Date.now();

	const elapsedSeconds = () =>
		Math.max(0, Math.floor((elapsedEndMs() - props.startedAtMs) / 1000));

	const [displaySeconds, setDisplaySeconds] = createSignal(elapsedSeconds());

	createEffect(() => {
		setDisplaySeconds(elapsedSeconds());
		if (props.thinkingEndedAtMs !== undefined) {
			return;
		}

		const intervalId = setInterval(
			() => setDisplaySeconds(elapsedSeconds()),
			1000,
		);
		onCleanup(() => clearInterval(intervalId));
	});

	return displaySeconds;
};
